
export const getPagination = (resp) => {
    const { page, size, max_page, total_pages, total, last, first, visible } = resp;
    return { page, size, max_page, total_pages, total, last, first, visible }
}

export const money = (val, friction = 2) => {
    if (!val) return 0
    return val.toLocaleString('id-ID', { maximumFractionDigits: friction });
}

export const nl2br = (str) => {
    if (typeof str !== 'string') return '';
    return str.replace(/\n/g, '<br/>');
}


export const generatePassword = (length = 12) => {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
    let password = '';
    for (let i = 0; i < length; i++) {
        const index = Math.floor(Math.random() * chars.length);
        password += chars.charAt(index);
    }
    return password;
}

export const groupBy = (array, key) => {
    return array.reduce((result, currentValue) => {
        (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
        return result;
    }, {});
}


export const noImage = (e) => {
    e.currentTarget.src = "/images/logo-toko21.png";
    (e.currentTarget).width = 30;
    (e.currentTarget).height = 30;
    return e
}
export const invertColor = (hex) => {
    let color = hex.startsWith('#') ? hex.slice(1) : hex;
    if (color.length === 3) {
        color = color.split('').map(char => char + char).join('');
    }
    if (color.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    const r = parseInt(color.slice(0, 2), 16);
    const g = parseInt(color.slice(2, 4), 16);
    const b = parseInt(color.slice(4), 16);
    const luma = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 255;
    return luma >= 0.5 ? '#000000' : '#FFFFFF';
}

export const statusColorMap = {
    PENDING: "bg-yellow-500",
    PREPARING: "bg-blue-500",
    IN_DELIVERY: "bg-green-500",
    IN_PROGRESS: "bg-orange-500",
    COMPLETED: "bg-indigo-500",
    delivered: "bg-indigo-500",
    COMPLETE: "bg-indigo-500",
    SETTLEMENT: "bg-indigo-500",
    allocated: "bg-orange-400",
    dropping_off: "bg-orange-400",
    picked: "bg-orange-400",
    picking_up: "bg-orange-400",
    PAID: "bg-indigo-500",
}